import { FormSwitch } from 'components/molecules/FormSwitch';
import { IOptionalFieldDetails } from 'models/settings';
import { ITableColumns, ITableDataSource } from 'models/table';

export enum EFieldsOptional {
  height = 'height',
  departmentName = 'departmentName',
  occupation = 'occupation',
  secondSurname = 'secondSurname',
  placeOfBirth = 'placeOfBirth',
}
interface IFieldsTableColumns {
  handleChangeVisibilityStatus: (name: string, status: boolean) => void;
  handleChangeRequiredStatus: (name: string, status: boolean) => boolean;
  notVisibleNames: string[];
  t: any;
  control: any;
  errors: any;
}

export const FieldsTableColumns = ({
  handleChangeVisibilityStatus,
  handleChangeRequiredStatus,
  notVisibleNames,
  t,
  control,
  errors,
}: IFieldsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'module',
    title: 'systemFieldsConfiguration.legalEntityType.column',
    isSortable: false,
    render: (_data, props) => (
      <div style={{ textTransform: 'capitalize' }}>{props.module.toLowerCase()}</div>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f510',
    key: 'name',
    title: 'systemFieldsConfiguration.fieldName.column',
    isSortable: false,
    render: (_data, props) => t(`legalEntityDetails.${props.name}.label`),
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f511',
    key: 'visible',
    title: 'systemFieldsConfiguration.fieldVisibility.column',
    isSortable: false,
    tooltipTitle: 'systemFieldsConfiguration.fieldVisibility.text',
    render: (_data, props) => (
      <FormSwitch
        name={`${props.name}.visible`}
        control={control}
        errors={errors}
        withValidation={false}
        onChangeStatus={(status: boolean) => handleChangeVisibilityStatus(props.name, status)}
      />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f513',
    key: 'required',
    title: 'systemFieldsConfiguration.fieldRequired.column',
    isSortable: false,
    tooltipTitle: 'systemFieldsConfiguration.fieldRequired.text',
    render: (_data, props) => (
      <FormSwitch
        name={`${props.name}.required`}
        control={control}
        errors={errors}
        withValidation={false}
        onChangeStatus={(status: boolean) => handleChangeRequiredStatus(props.name, status)}
        disabled={notVisibleNames.includes(props.name)}
      />
    ),
  },
];

export const mapFieldsToDataSource = (items: IOptionalFieldDetails[]): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    module: item.module,
    name: item.name,
    visible: item.visible,
    required: item.required,
  }));
